
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';

import Header from "../components/header";
import Footer from "../components/footer";
import Zoom from "react-medium-image-zoom";

import videos from "../assets/images/img/Masterplan/Masterplan-GIF.mp4"
import breath01 from "../assets/images/img/Masterplan/Boundaries-That-Breathe-1.png"
import breath02 from "../assets/images/img/Masterplan/Boundaries-That-Breathe-2.png"

import masterplan01 from "../assets/images/masterplan/Masterplan-1.webp"
import masterplan02 from "../assets/images/newimage/masterplan/masterplan-2-.png"
import masterplan03 from "../assets/images/masterplan/Masterplan-3.webp"

import banner01 from "../assets/images/masterplan-gallery/masterplan-gallery-1.webp"
import banner02 from "../assets/images/masterplan-gallery/masterplan-gallery-2.webp"
import banner03 from "../assets/images/masterplan-gallery/masterplan-gallery-3.webp"
import banner04 from "../assets/images/masterplan-gallery/masterplan-gallery-4.webp"
import banner05 from "../assets/images/masterplan-gallery/masterplan-gallery-5.webp"
import banner06 from "../assets/images/masterplan-gallery/masterplan-gallery-6.webp"
import banner07 from "../assets/images/masterplan-gallery/masterplan-gallery-7.webp"
import banner08 from "../assets/images/masterplan-gallery/masterplan-gallery-8.webp"
import banner09 from "../assets/images/masterplan-gallery/masterplan-gallery-9.webp"
import banner10 from "../assets/images/masterplan-gallery/masterplan-gallery-10.webp"


import banner17 from "../assets/images/newimage/masterplan/Gallery-17.png"
import banner18 from "../assets/images/newimage/masterplan/Gallery-18.png"
import banner19 from "../assets/images/newimage/masterplan/Gallery-19.png"
import banner20 from "../assets/images/newimage/masterplan/Gallery-20.png"
import banner21 from "../assets/images/newimage/masterplan/Gallery-21.png"
import banner22 from "../assets/images/newimage/masterplan/Gallery-22.png"
import banner26 from "../assets/images/newimage/masterplan/Gallery-26.png"
import banner27 from "../assets/images/newimage/masterplan/Gallery-27.png"
import banner28 from "../assets/images/newimage/masterplan/Gallery-28.png"


import landscape01 from "../assets/images/newimage/masterplan/1.png"
import landscape02 from "../assets/images/newimage/masterplan/10.png"
import landscape03 from "../assets/images/newimage/masterplan/11.png"
import landscape04 from "../assets/images/newimage/masterplan/12.png"
import landscape05 from "../assets/images/newimage/masterplan/13.png"
import landscape06 from "../assets/images/newimage/masterplan/14.png"
import landscape07 from "../assets/images/newimage/masterplan/15.png"


const banners = [
    {src:banner17},
{src:banner18},
{src:banner19},
{src:banner20},
{src:banner21},
{src:banner22},
{src:banner26},
{src:banner27},
{src:banner28},
    {src:landscape01},
    {src:landscape02},
    {src:landscape03},
    {src:landscape04},
    {src:landscape05},
    {src:landscape06},   
     {src:landscape07},  
    {src:banner01 },
    {src:banner02 },
    {src:banner03 },
    {src:banner04 },
    {src:banner05},
    {src:banner06 },
    {src:banner07 },
    {src:banner08},
    {src:banner09 },
    {src:banner10 },
]

const masterplans = [
{
title: "Enclaves of Sustainability",
id: "dbbd0881",
class: "Masterplan-images01",
subtitle: "Nestled within its embrace are sustainable enclaves, where nature and community thrive side by side.",
},
{
title: "Oases of Leisure",
id: "dbbd0882",
class: "Masterplan-images02",
subtitle: "Leisure and amusement centres invite laughter and joy, offering spaces for families to gather and create cherished memories.",
},
{
title: "Convenience at Your Doorstep",
id: "dbbd0883",
class: "Masterplan-images03",
subtitle: "Convenience stores stand ready to serve, ensuring that everyday needs are met with ease and grace.",
},
{
title: "Parks of Serenity",
id: "dbbd0884",
class: "Masterplan-images04",
subtitle: "Dozens of parks dot the landscape, each a sanctuary of tranquility where the laughter of children mingles with the rustle of leaves.",
},
{
title: "Gardens of Abundance",
id: "dbbd0885",
class: "Masterplan-images05",
subtitle: "Lush gardens flourish, bearing fruits and flowers that celebrate the beauty of nature’s bounty.",
},
{
title: "Paths of Discovery",
id: "dbbd0886",
class: "Masterplan-images06",
subtitle: "Winding trails beckon explorers to wander, inviting them to discover hidden corners and the wonders of biodiversity.",
},
{
title: "Spaces for Connection",
id: "dbbd0887",
class: "Masterplan-images07",
subtitle: "Community gathering spots foster connection, where neighborscome together to share stories and cultivate friendships.",
},
{
title: "A Canvas for Creativity",
id: "dbbd0888",
class: "Masterplan-images08",
subtitle: "Artful installations inspire creativity, transforming the environment into a gallery that reflects the spirit of its inhabitants.",
}
]

gsap.registerPlugin(ScrollTrigger);

export default function Masterplan() {

    return (
       <div className="dody-container">
       <Header />
       <section>

           <div className='biome biome-687'>

               <div
                   className="biome-element biome-element-31088fa e-flex e-con-boxed e-con e-parent e-lazyloaded the-masterplan">
                   <div className="e-con-inner">
                       <div className="biome-element biome-element-204e737 e-con-full e-flex e-con e-child">

                           <div
                               className="biome-element biome-element-8b6c9ce biome-widget biome-widget-elementskit-heading animated ">
                               <div className="biome-widget-container">
                                   <div className="ekit-wid-con">
                                       <div
                                           className="ekit-heading elementskit-section-title-wraper text_center   ekit_heading_tablet-   ekit_heading_mobile-">
                                           <h1 className="ekit-heading--title elementskit-section-title "> The
                                               Masterplan </h1>
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </div>
                   </div>
               </div>

               <div
                   className="biome-element biome-element-4f1f6db e-flex e-con-boxed e-con e-parent e-lazyloaded biome-kit-5-bg-white">
                   <div className="e-con-inner animate-section-trigger  section-scroll-animation">

                       <div className="biome-element biome-element-8bcebe5 e-con-full e-flex e-con e-child">

                          <div className="swiper-controls-icons swiper-controls"> <button
                                className="swiper-prev-icon"><svg xmlns="http://www.w3.org/2000/svg" width="16"
                                    height="16" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd"
                                        d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
                                </svg></button> <button className="swiper-next-icon"><svg
                                    xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                    class="bi bi-arrow-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd"
                                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                </svg></button> </div>

                        <Swiper loop={true} autoplay={{
                    delay: 4000,
                    disableOnInteraction: false,
                }} allowTouchMove={true} navigation={{
                    prevEl: ".swiper-prev-icon",
                    nextEl: ".swiper-next-icon",
                }} modules={[Autoplay, Navigation]} spaceBetween={24} slidesPerView={3} breakpoints={{
                    0: {
                    slidesPerView: 1,   
                    // spaceBetween: 12,
                    },
                    760: {
                    slidesPerView: 1, 
                    spaceBetween: 0,
                    },
                    1024: {
                    slidesPerView: 1,  
                    // spaceBetween: 24,
                    },
                }}>
 <SwiperSlide>
    <div class="biome-element biome-element-8bcebe5 e-con-full e-flex e-con e-child biome-widget-margin-top-60">
   <div className="biome-element biome-element-1fce1d2 e-con-full e-flex e-con e-child ">
                              <div
                                   className="biome-element biome-element-386b5e8  biome-widget biome-widget-text-editor">
                                   <div className="biome-widget-container">
                                       <p data-anim="fade-up" className='title-anim gsap-text'>
                                           The masterplan at Biome is shaped by the land first its slopes,
                                           waterflows, soil, and existing vegetation so that development follows
                                           ecology, not the other way around. Built footprints are carefully placed to
                                           preserve natural drainage, protect trees, and keep large continuous tracts
                                           for rewilding, farming, and shared open space.
                                       </p>
                                   </div>
                               </div>
                               <div
                                   className="biome-element biome-element-7915149 biome-widget biome-widget-image animated  bdFadeUp">
                                   <div className="biome-widget-container">
                                       <img width="800" height="667" src={masterplan01}
                                           className="attachment-full size-full wp-image-122" alt={masterplan01} />
                                   </div>
                               </div>
                             

                           </div>
                      <div className="biome-element biome-element-bb60c9b e-con-full e-flex e-con e-child">
                               <div
                                   className="biome-element biome-element-7915149 biome-widget biome-widget-image animated bdFadeUp">
                                   <div className="biome-widget-container">
                                       <img width="800" height="667" src={masterplan03}
                                           className="attachment-full size-full wp-image-122" alt={masterplan03} />
                                   </div>
                               </div>
                               <div
                                   className="biome-element biome-element-386b5e8  biome-widget biome-widget-text-editor">
                                   <div className="biome-widget-container">
                                       <p data-anim="fade-up" className='title-anim gsap-text'>
                                           Movement within the masterplan prioritises slow, human scale experiences:
                                           internal roads are minimal, with loops for essential access, while walking,
                                           cycling, and barefoot trails connect commons, farms, play areas, and quiet
                                           zones. Services power, water, waste, and sanitation are planned as site wide
                                           systems with decentralised, low impact infrastructure, making the settlement
                                           more resilient to climate and resource stresses over time.
                                       </p>
                                   </div>
                               </div>

                           </div>
    </div>
                     
                    </SwiperSlide>
                          <SwiperSlide>
                      <div className="biome-element biome-element-maping">
                               <div
                                   className="biome-element biome-element-42c32f0 biome-widget biome-widget-text-editor animated ">
                                   <div className="biome-widget-container">
                                       <p data-anim="fade-up" className='title-anim gsap-text'>
                                         The Biome Farm is envisioned as a biodiverse and resilient community landscape within the rapidly urbanizing fabric of the Rayalaseema region. Set in a drought prone semi arid ecology, the project responds to the challenges of climate change, which has brought more erratic and intense rainfall patterns. Drawing inspiration from the prosperity and resilience of the Vijayanagara dynasty, the project aspires to become a model for water conservation, ecological resilience, and productive landscapes that nurture both biodiversity and community well being. Rooted in the Deccan Plateau and informed by local ecological patterns, the design employs native, drought-tolerant species and locally sourced materials to craft a landscape that is both resilient and deeply connected to place. The farm integrates closed habitats such as woodlands, orchards, food forests, hedgerows and biodiverse groves, with open habitats, including savannas, grasslands, wetlands, nectar gardens, meadows, and gathering spaces. Together, these create a mosaic that supports birds, pollinators, and diverse flora and fauna, while offering future ready investment with restorative, sensorial experiences for people. The landscape strategy synthesizes ecological landscape design, regenerative and syntrophic farming, permaculture principles, and nature based solutions, positioning the farm as a living demonstration of resilient and regenerative land stewardship.
                                       </p>
                                   </div>
                               </div>
                               <div
                                   className="biome-element biome-element-378177c  biome-widget biome-widget-image bdFadeUp">
                                   <div className="biome-widget-container">
                                       <img decoding="async" width="960" height="640" src={masterplan02}
                                           className="attachment-full size-full wp-image-729" alt={masterplan02} />
                                   </div>
                               </div>
                           </div>
                    </SwiperSlide>
                   
                </Swiper>
                           
                        

                         


                       </div>

                   </div>
               </div>

               <div
                   className="biome-element biome-element-4f1f6db e-flex e-con-boxed e-con e-parent e-lazyloaded biome-kit-5-bg-white section-scroll-animation green-background-12">
                   <div className="e-con-inner animate-section-trigger">
                       <div className="biome-element biome-element-8bcebe5 e-con-full e-flex e-con e-child">

                           <div
                               className="biome-element biome-element-1fce1d2 e-con-full e-flex e-con e-child section-scroll-animation">
                               <div
                                   className="biome-element biome-element-42c32f0 biome-widget biome-widget-text-editor animated ">
                                   <div className="biome-widget-container">
                                       <h2 data-anim="fade-up" className='title-anim attr-text-white gsap-text'>
                                           Boundaries That Breathe
                                       </h2>
                                   </div>
                               </div>
                               <div
                                   className="biome-element biome-element-378177c  biome-widget biome-widget-image bdFadeUp">
                                   <div className="biome-widget-container">
                                       <img decoding="async" width="960" height="640" src={breath01}
                                           className="attachment-full size-full wp-image-729 wp-image-122-top"
                                           alt={breath01} /> </div>
                               </div>
                               <div
                                   className="biome-element biome-element-386b5e8  biome-widget biome-widget-text-editor">
                                   <div className="biome-widget-container">
                                       <p data-anim="fade-up" className='title-anim attr-text-white gsap-text'>
                                           At BIOME, your nesting is embraced not by walls or fences, but by the
                                           landscape itself. Stone lined bunds and sculpted natural contours create soft, protective
                                           boundaries around each plot, defining your space with intention and care. </p>

                                   </div>
                               </div>
                           </div>

                           <div
                               className="biome-element biome-element-bb60c9b e-con-full e-flex e-con e-child section-scroll-animation">
                               <div
                                   className="biome-element biome-element-7915149 biome-widget biome-widget-image animated  bdFadeUp">
                                   <div className="biome-widget-container">
                                       <img width="800" height="667" src={breath02}
                                           className="attachment-full size-full wp-image-122 wp-image-122-bottom"
                                           alt={breath02} /> </div>
                               </div>
                               <div
                                   className="biome-element biome-element-386b5e8  biome-widget biome-widget-text-editor">
                                   <div className="biome-widget-container">

                                       <p data-anim="fade-up" className='title-anim attr-text-white gsap-text'>
                                           Every nesting is purposefully designed to integrate with the surrounding
                                           forest offering a three dimensional view of native trees from all directions. This living
                                           canopy not only creates a layered sense of seclusion, but also frames picturesque views of
                                           foliage, light, and sky turning privacy into poetry.
                                       </p>

                                       <p data-anim="fade-up" className='title-anim attr-text-white gsap-text'>
                                           These earth formed bunds act as quiet guardians, buffering each home from
                                           shared spaces while maintaining openness, breeze, and connection to the wider
                                           ecology. Overtime, they welcome vines, wildflowers, and birds evolving into living edges
                                           that blur the line between home and habitat.This is design that listens to the land, to the
                                           light, and to the need for peace.
                                       </p>

                                   </div>
                               </div>

                           </div>

                       </div>
                   </div>
               </div>

               <div
                   className="biome-element biome-element-4f1f6db e-flex e-con-boxed e-con e-parent e-lazyloaded biome-kit-5-bg-white section-scroll-animation">
                   <div className="e-con-inner animate-section-trigger">
                       <div className="biome-element biome-element-47b1a33 e-con-full e-flex e-con e-child">
                           <div
                               className="biome-widget-container elementskit-section-title-wraper text_center biome-kit-5-height-full bdFadeUp">
                               <video className="image-full is--laptop biome-absolute-top biome-kit-5-sticky" autoPlay
                                   loop muted>
                                   <source src={videos} type='video/mp4' />
                               </video>
                           </div>
                       </div>
                   </div>
               </div>
           </div>
           <div className="biome biome-24">
               <div
                   className="biome-element biome-element-8570b72 e-flex e-con-boxed e-con e-parent e-lazyloaded biome-kit-5-bg-white biome-fieldhouse">
                   <a href="/architectural-consideration" target='_blank'
                       className="e-con-inner animate-section-trigger">
                       <div
                           className="biome-element biome-element-47b1a33 e-con-full e-flex e-con e-child section-scroll-animation">

                           <div
                               className="biome-element biome-element-e9056c4 biome-widget biome-widget-elementskit-heading animated fadeInUp">
                               <div className="biome-widget-container">
                                   <div className="ekit-wid-con">
                                       <div
                                           className="ekit-heading elementskit-section-title-wraper text_left   ekit_heading_tablet-   ekit_heading_mobile-">
                                           <h2 data-anim="rotate"
                                               className="ekit-heading--title elementskit-section-title  animation__char_come gsap-text ">
                                               Architectural consideration in designing the masterplan
                                           </h2>
                                       </div>
                                   </div>
                               </div>
                           </div>

                           <div className="biome-element biome-element-0078ee0 e-con-full e-flex e-con e-child">
                               <div className="biome-element biome-element-9e1a0ed e-con-full e-flex e-con e-child">
                                   <div
                                       className="biome-element biome-element-43cdaa5 biome-widget biome-widget-text-editor animated fadeInUp">
                                       <div className="biome-widget-container">
                                           <p data-anim="fade-up" className='title-anim gsap-text'>Drawing inspiration
                                               from the land’s memory, our architecture weaves local materials and
                                               thriving ecology into sanctuaries that nurture heritage, abundance, and
                                               living connection.</p>
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </div>

                       <div
                           className="biome-element biome-element-4de30ba e-grid e-con-full e-con e-child section-scroll-animation">
                           <div
                               className="biome-element biome-element-dbbd088 e-con-full e-flex e-con e-child animated bdFadeUp">
                               <div
                                   className="biome-element biome-element-870ab2b biome-view-framed biome-position-right biome-mobile-position-right biome-shape-circle biome-widget biome-widget-icon-box">
                                   <div className="biome-widget-container">
                                       <div className="biome-icon-box-wrapper">

                                           <div className="biome-icon-box-content biome-card-sticky">
                                               <h4 data-anim="rotate"
                                                   className="biome-icon-box-title  animation__char_come gsap-text ">The
                                                   Design
                                               </h4>
                                               <p data-anim="fade-up" className="title-anim gsap-text">Local materials
                                                   and ancient patterns, shaping structures that honor terrain’s natural
                                                   contours, heritage, and enduring spirit.</p>
                                           </div>

                                       </div>
                                   </div>
                               </div>
                           </div>

                           <div
                               className="biome-element biome-element-5eddd9c e-con-full e-flex e-con e-child animated bdFadeUp">
                               <div
                                   className="biome-element biome-element-f079dc5 biome-view-framed biome-position-right biome-mobile-position-right biome-shape-circle biome-widget biome-widget-icon-box">
                                   <div className="biome-widget-container">
                                       <div className="biome-icon-box-wrapper">

                                           <div className="biome-icon-box-content biome-card-sticky">
                                               <h4 data-anim="rotate"
                                                   className="biome-icon-box-title  animation__char_come gsap-text ">
                                                   Landscape
                                               </h4>
                                               <p data-anim="fade-up" className="title-anim gsap-text">Layered trees,
                                                   shrubs, crops, and water channels unite landscape and
                                                   architecture elements nurturing sustainability, heritage, and
                                                   vibrancy.</p>
                                           </div>

                                       </div>
                                   </div>
                               </div>
                           </div>

                           <div
                               className="biome-element biome-element-cb27831 e-con-full e-flex e-con e-child animated bdFadeUp">
                               <div
                                   className="biome-element biome-element-39dc98f biome-view-framed biome-position-right biome-mobile-position-right biome-shape-circle biome-widget biome-widget-icon-box">
                                   <div className="biome-widget-container">
                                       <div className="biome-icon-box-wrapper">

                                           <div className="biome-icon-box-content biome-card-sticky">
                                               <h4 data-anim="rotate"
                                                   className="biome-icon-box-title  animation__char_come gsap-text ">
                                                   Conservation
                                               </h4>
                                               <p data-anim="fade-up" className="title-anim gsap-text">Amidst arid
                                                   breath, a tapestry of life blooms canopy arms, fragrant shrubs, and
                                                   refuge for all wings and roots through every season.</p>
                                           </div>

                                       </div>
                                   </div>
                               </div>
                           </div>

                       </div>

                   </a>
               </div>
               <div
                   className="biome-element biome-element-8570b72 e-flex e-con-boxed e-con e-parent e-lazyloaded full-background-green biome-location section-scroll-animation">
                   <div className="e-con-inner animate-section-trigger">
                       <div className="biome-element biome-element-47b1a33 e-con-full e-flex e-con e-child">

                           <div
                               className="biome-element biome-element-e9056c4 biome-widget biome-widget-elementskit-heading animated fadeInUp">
                               <div className="biome-widget-container">
                                   <div className="ekit-wid-con">
                                       <div
                                           className="ekit-heading elementskit-section-title-wraper text_left   ekit_heading_tablet-   ekit_heading_mobile-">
                                           <h2 data-anim="rotate"
                                               className="ekit-heading--title elementskit-section-title attr-text-white  animation__char_come gsap-text ">
                                               At Biome embrace the essence of a flourishing ecosystem,
                                               this agroforestry project unfolds like a vibrant tapestry, rich with
                                               possibilities.
                                           </h2>
                                       </div>
                                   </div>
                               </div>
                           </div>

                       </div>

                       <div className="biome-element biome-element-4de30ba e-grid e-con-full e-con e-child">
                           {masterplans.map((masterplan, i) => (
                           <div className={`biome-element biome-element-dbbd088 e-con-full e-flex e-con e-child animated
                               bdFadeUp`} kay={i} id={masterplan.id}>
                               <div
                                   className="biome-element biome-element-870ab2b biome-view-framed biome-position-right biome-mobile-position-right biome-shape-circle biome-widget biome-widget-icon-box">
                                   <div className="biome-widget-container">
                                       <div className="biome-icon-box-wrapper">

                                           <div className="biome-icon-box-content biome-card-sticky">
                                               <h4 data-anim="rotate"
                                                   className="biome-icon-box-title  animation__char_come gsap-text ">
                                                   {masterplan.title}
                                               </h4>
                                               <p data-anim="fade-up" className="title-anim gsap-text">
                                                   {masterplan.subtitle}
                                               </p>
                                           </div>

                                       </div>
                                   </div>
                               </div>
                           </div>
                           ))}
                       </div>

                   </div>
               </div>



           </div>
           <div className='biome biome-687'>

               <div
                   className="biome-element biome-element-4f1f6db e-flex e-con-boxed e-con e-parent e-lazyloaded animate-section-trigger">
                   <div className="e-con-inner animate-section-trigger section-scroll-animation">

                       <div
                           className="biome-element biome-element-ed8c4d1 biome-widget biome-widget-elementskit-heading animated ">

                           <div className="biome-widget-container">
                               <div className="ekit-wid-con">
                                   <div
                                       className="ekit-heading elementskit-section-title-wraper text_left   ekit_heading_tablet-   ekit_heading_mobile-">
                                       <h2 data-anim="rotate"
                                           className="ekit-heading--title elementskit-section-title title-anim gsap-text">
                                           Masterplan & Landscape Visions</h2>
                                   </div>
                               </div>
                           </div>
                       </div>
                       <div className="biome-element biome-element-8bcebe59 gallery-cont bdFadeUp">
                           {banners.map((banner, i) => (
                           <div className="gallery-banner">
                               <Zoom key={i}>
                                   <img width="800" height="667" src={banner.src}
                                       className="attachment-full size-full wp-image-122" alt={banner.src}/>
                               </Zoom>
                           </div>

                           ))}
                       </div>
                   </div>
               </div>
           </div>
       </section>
       <Footer />
   </div>
    )
}